import { Component, ChangeDetectionStrategy, inject, signal, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Button } from 'primeng/button';
import { AbstractPageComponent, BasePageComponent, NoResultComponent } from '@spike/scaffolds';
import { AsyncApiService, ResourceApiService } from '@spike/core';
import { Trade } from '../../models/trade.model';
import { EntityApiEnum } from 'src/app/config/entity-api.enum';
import { PaginationModel } from '../../models/pagination-model';
import { SortingModel } from '../../models/sorting.model';
import { TradesTableComponent } from "../../components/trades-table/trades-table";
import { Paginator } from "primeng/paginator";
import { TradeSidePanelComponent } from "../../toggle-panels/trade-side-panel/trade-side-panel";
import { AccountTransferSidePanelComponent } from "../../toggle-panels/account-transfer-side-panel/account-transfer-side-panel";
import { TradeFiltersFormComponent } from "../../forms/trade-filters-form/trade-filters-form";

@Component({
  selector: 'spike-trade-page',
  templateUrl: './trade-page.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, Button, BasePageComponent, NoResultComponent, TradesTableComponent, Paginator, TradeSidePanelComponent, AccountTransferSidePanelComponent, TradeFiltersFormComponent]
})
export class TradePageComponent extends AbstractPageComponent {
  private readonly resourceApi = inject(ResourceApiService);
  private readonly asyncApi = inject(AsyncApiService);

  public readonly breadcrumb = [{label:'Lista Operazioni liquidità'}];

  private readonly tradeApiEnum = EntityApiEnum.FIN_TRADE;
  public readonly pagination = signal<PaginationModel>({ rows: 25, currentPage: 0, first: 0, rowsPerPageOptions: [25, 50, 100] });
  public readonly sorting = signal<SortingModel>({ orderByClause: 'accounting_date', orderDirection: 'desc' });
  public readonly selectedTrade = signal<Trade|undefined>(undefined);
  public readonly isSidepanelTradeVisibile= signal<boolean>(false);
  public readonly isSidepanelAccountTransferVisibile= signal<boolean>(false);
  public readonly finTradeTypeId = signal<number>(0);

  public readonly searchFilter = signal<Trade>({} as Trade);
  public readonly resourceFilter = computed(()=>{
    const searchFilter = this.searchFilter()
    const pagination = this.pagination();
    const sorting = this.sorting();
    return { filter: searchFilter,  likable: true, currentPage: pagination.currentPage, maxResultPerPage: pagination.rows, orderByClause: sorting.orderByClause, orderDirection: sorting.orderDirection };

  })

  public readonly tradeResource = this.resourceApi.call<any>(signal(this.tradeApiEnum),signal('search'), this.resourceFilter);

  public trades = computed(()=>{
    const tradeResource = this.tradeResource.value();
    return tradeResource;

  });

  public onPageChange(event: any): void {
    this.pagination.update(p => ({...p, rows: event.rows || p.rows, first: event.first || 0, currentPage: event.page || 0}));
  }

  public onSort(sortingModel: SortingModel) {
    this.sorting.set(sortingModel);
  }


  public onSave(){
    this.tradeResource.reload();
  } 

  public openTradeInDialog(){
    this.finTradeTypeId.set(1);
    this.openTradeDialog();
  }

  public openTradeOutDialog(){
    this.finTradeTypeId.set(2);
    this.openTradeDialog();
  }

  public async openTradeDialog(trade?: Trade){
    if(trade?.finTradeId){
      trade = await this.asyncApi.selectById<Trade>(this.tradeApiEnum, trade.finTradeId);
      this.finTradeTypeId.set(trade.finTradeTypeId);
    }
    this.selectedTrade.set(trade);
    this.isSidepanelTradeVisibile.set(true);
  }

  public async openAccountTransferDialog(){
    this.isSidepanelAccountTransferVisibile.set(true);
  }

  closeSidePanel(){
    this.isSidepanelAccountTransferVisibile.set(false);
    this.isSidepanelTradeVisibile.set(false);
    this.selectedTrade.set(undefined);
  }

   onDelete(){
    this.tradeResource.reload();
    this.closeSidePanel();
  }
  
}